import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import { Card, CardTitle } from "reactstrap";
import NumericFormat from "../../../../components/react-number-format/NumericFormat";
import { loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc, loadOperationsByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdAndStateIdInAndRequestedCurrencyAmountLessThan } from "../../../../actions";
import { engagedOperationStateIdsStr, operationTypes } from "../../../../constants";
var tKey = "contexts.ExchangeContext.CreateExchangeDialog.ExchangeWizardForm.ExchangeWizardFormAmountAvailableSellStep";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormAmountAvailableSellStep(props) {
  var broker = useSelector(function (state) {
    return selector(state, "broker");
  });
  var brokerId = broker.id;
  var price = useSelector(function (state) {
    return selector(state, "price");
  });
  var currencyId = price.currency.id;
  var goal = useSelector(function (state) {
    return selector(state, "goal");
  });
  var goalId = goal.id;
  var goalIdStr = goalId === -1 ? "null" : goalId;
  var variantInvestmentItemRoot = useSelector(function (state) {
    return selector(state, "variantInvestmentItemRoot");
  });
  var investmentItem = variantInvestmentItemRoot;
  var investmentItemId = investmentItem.id;
  var user = useSelector(function (state) {
    return selector(state, "user");
  });
  var userId = user.id;
  var balance = useSelector(function (state) {
    return state.entities.brokerCurrencyGoalInvestmentItemUserBalances.firstByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc[[brokerId, currencyId, goalIdStr, investmentItemId, userId].join("-")];
  });
  var balanceInvestmentItemAmount = balance ? balance.investmentItemAmount : 0;
  var engagedOperations = useSelector(function (state) {
    return state.entities.operations.byBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdAndStateIdInAndRequestedCurrencyAmountLessThan[[brokerId, currencyId, goalIdStr, investmentItemId, userId, engagedOperationStateIdsStr, 0].join("-")];
  });
  var engagedInvestmentItemAmount = engagedOperations && engagedOperations.filter(function (operation) {
    return operation.type === operationTypes.SELL;
  }).reduce(function (accumulator, _ref) {
    var investmentItemAmount = _ref.investmentItemAmount;
    return accumulator + investmentItemAmount;
  }, 0);
  var investmentItemAmountAvailable = balanceInvestmentItemAmount - engagedInvestmentItemAmount;
  useEffect(function () {
    props.loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc(brokerId, currencyId, goalId === -1 ? null : goalId, investmentItemId, userId);
    props.loadOperationsByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdAndStateIdInAndRequestedCurrencyAmountLessThan(brokerId, currencyId, goalId === -1 ? null : goalId, investmentItemId, userId, engagedOperationStateIdsStr, 0);
  }, []);
  useMemo(function () {
    props.change("investmentItemAmountAvailable", investmentItemAmountAvailable);
    props.change("engagedInvestmentItemAmount", engagedInvestmentItemAmount);
  }, [investmentItemAmountAvailable, engagedInvestmentItemAmount]);
  return /*#__PURE__*/React.createElement(Card, {
    body: true,
    inverse: true,
    color: "brand-primary",
    className: "m-0 rounded"
  }, /*#__PURE__*/React.createElement(CardTitle, {
    tag: "h4",
    className: "m-0"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NumericFormat, {
    displayType: "text",
    value: investmentItemAmountAvailable,
    className: "me-1",
    style: {
      fontWeight: 600
    }
  }), /*#__PURE__*/React.createElement("small", null, investmentItem.unitAbbreviation)), engagedInvestmentItemAmount !== 0 && /*#__PURE__*/React.createElement("div", {
    className: "small"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".committedSell"),
    components: {
      amount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        value: engagedInvestmentItemAmount,
        style: {
          fontWeight: 600
        }
      })
    },
    values: {
      unitAbbreviation: investmentItem.unitAbbreviation
    }
  }))));
}
export default connect(undefined, {
  loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc: loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc,
  loadOperationsByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdAndStateIdInAndRequestedCurrencyAmountLessThan: loadOperationsByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdAndStateIdInAndRequestedCurrencyAmountLessThan
})(ExchangeWizardFormAmountAvailableSellStep);
ExchangeWizardFormAmountAvailableSellStep.propTypes = {
  loadFirstBrokerCurrencyGoalInvestmentItemUserBalanceByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdOrderByInstantDesc: PropTypes.func,
  loadOperationsByBrokerIdAndCurrencyIdAndGoalIdAndInvestmentItemIdAndUserIdAndStateIdInAndRequestedCurrencyAmountLessThan: PropTypes.func
};